import { useEffect } from "react";
import Input from "../../../form/Input";
import useForm from "../../../../hooks/useForm";
import Button from "../../../form/Button";
import useMutation from "../../../../hooks/useMutation";
import { emailTemplateAddEdit } from "../../../../services/emailService";
import TinyEditor from "../../../form/TinyEditor";

const validation = {
  // subject: { required: true, message: "Email subject is required" },
  content: { required: true, message: "Email content is required" },
  fromName: { required: true, message: "Sender name is required" },
};

const ManageEmailTemplate = ({
  getResponse = () => {},
  close = () => {},
  data,
}) => {
  const {
    values,
    handleChange,
    handleSubmit,
    errors,
    setFieldsValue,
    resetField,
    formValidate,
  } = useForm({
    validationRules: validation,
    initialState: {
      subject: "",
      fromName: "",
      content: "",
    },
  });

  useEffect(() => {
    if (data?._id) {
      setFieldsValue(data);
    }
  }, [data]);

  const {
    mutate,
    error,
    isPending: isLoading,
  } = useMutation({
    mutationFn: async (val) => {
      return await emailTemplateAddEdit({
        ...val,
        ...(data?._id && { id: data?._id }),
      });
    },
    onSuccess: (res) => {
      getResponse(res);
      return res;
    },
    onError: (error) => {
      console.log(error);
    },
  });

  return (
    <form onSubmit={(event) => handleSubmit(event, mutate)}>
      <div className="grid grid-cols-12 gap-x-4 gap-y-4">
        {/* <div className="relative col-span-6">
          <Input
            label="Email Subject"
            inputPlaceholder={"Enter Email Subject"}
            inputName="subject"
            value={values?.subject}
            onChange={handleChange}
            {...formValidate(errors, "subject")}
          />
        </div> */}
        <div className="relative col-span-12">
          <Input
            label="Sender Name"
            inputPlaceholder={"Enter Sender Name"}
            inputName="fromName"
            value={values?.fromName}
            onChange={handleChange}
            {...formValidate(errors, "fromName")}
          />
        </div>
        <div className="relative col-span-12">
          <TinyEditor
            label="Email Body"
            value={values?.content}
            onChange={(val) => {
              handleChange({
                target: { name: "content", value: val },
              });
            }}
            {...formValidate(errors, "content")}
          />
        </div>
      </div>
      <div className="relative col-span-4 mt-5">
        <div className="flex items-center justify-center gap-4">
          <Button
            buttonType="submit"
            buttonLabel={"Save"}
            buttonClasses={
              "!rounded-full !px-8 !h-12 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
            }
            buttonLabelClasses={"mx-auto"}
            {...(isLoading && {
              loading: true,
              buttonIconPosition: "left",
              isDisable: true,
            })}
          />
          <Button
            buttonLabel={"Cancel"}
            buttonClasses={
              "!rounded-full !px-8 !h-12 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
            }
            buttonLabelClasses={"mx-auto"}
            buttonFunction={close}
          />
        </div>
      </div>
    </form>
  );
};

export default ManageEmailTemplate;
